// src/services/ReporteService.js
import fetch from 'auth/FetchInterceptor';

const ReporteService = {};

ReporteService.getDashboard = function (params = {}) {
    return fetch({
        url: '/v1/reportes/dashboard',
        method: 'get',
        params,
    });
};

ReporteService.getMapa = function (params = {}) {
    return fetch({
        url: '/v1/reportes/mapa',
        method: 'get',
        params,
    });
};

// Devuelve el archivo como Blob. El interceptor entrega solo el cuerpo,
// así que el nombre del archivo lo arma quien descarga.
ReporteService.exportAsistencias = function (params = {}) {
    return fetch({
        url: '/v1/reportes/asistencias/export',
        method: 'get',
        params,
        responseType: 'blob',
    });
};

// Con responseType 'blob' también los errores llegan como Blob: se lee
// el JSON del 422 para mostrar el mensaje del backend.
ReporteService.mensajeDeError = async function (blob) {
    try {
        const cuerpo = JSON.parse(await blob.text());
        return cuerpo.errors?.formato?.[0] || cuerpo.message || 'No se pudo exportar.';
    } catch {
        return 'No se pudo exportar.';
    }
};

export default ReporteService;
